'use client';

import React from 'react';

interface UserProfileAvatarProps {
  name: string;
  profileImageUrl?: string | null;
  size?: 'sm' | 'md';
  className?: string;
  ringClassName?: string;
  /** Applied to initials fallback (e.g. sidebar brand color). */
  fallbackClassName?: string;
}

const sizeClasses = {
  sm: 'w-8 h-8 text-xs',
  md: 'w-10 h-10 text-sm',
};

export default function UserProfileAvatar({
  name,
  profileImageUrl,
  size = 'sm',
  className = '',
  ringClassName = '',
  fallbackClassName = 'bg-gradient-to-br from-[var(--hrm-primary)] to-[var(--hrm-primary-dark)]',
}: UserProfileAvatarProps) {
  const initials =
    name
      .split(/\s+/)
      .filter(Boolean)
      .map((n) => n[0]?.toUpperCase() ?? '')
      .join('')
      .slice(0, 2) || '?';

  const sizeClass = sizeClasses[size];

  return (
    <div
      className={`rounded-full overflow-hidden flex-shrink-0 ${sizeClass} ${ringClassName} ${className}`}
    >
      {profileImageUrl ? (
        <img
          src={profileImageUrl}
          alt={name}
          className="w-full h-full object-cover"
        />
      ) : (
        <div
          className={`w-full h-full flex items-center justify-center text-white font-bold ${fallbackClassName}`}
        >
          {initials}
        </div>
      )}
    </div>
  );
}
